module.exports = __webpack_public_path__ + "static/media/EU.e63b4e78.png";